"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERole = void 0;
var ERole;
(function (ERole) {
    ERole["ADMIN"] = "ADMIN";
    ERole["MANAGER"] = "MANAGER";
    ERole["USER"] = "USER";
})(ERole || (exports.ERole = ERole = {}));
